/* eslint-disable jsx-a11y/anchor-is-valid */
import { useRef } from 'react';
import searchImg from '../assets/images/search.svg';
import question from '../assets/images/question.svg';
import dashboard from '../assets/images/dashboard.svg';
import arrowDown from '../assets/images/down.png';
import arrowUp from '../assets/images/arrow_up.png';
import { toggleBookMode } from '../Store/settings/siteSettings';
import { useDispatch, useSelector } from 'react-redux';
import teextImg from '../assets/images/teext.svg';
import textImg from '../assets/images/text.svg';
import bellImg from '../assets/images/bell.svg';
import { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { forStudent, studentClassSection } from '../Store/api/activities';
import { getBook } from '../Store/api/student';
import { ProfileDropdown } from '../shared/ProfileDropdown';

export const StudentHeader = ({ canLeave, style = {}, dropdownWidth = '', searchBarWidth = '', setIsShowModal = () => {}, setModelSuccessUrl = () => {}, setDropDownActions = () => {} }) => {
  const { settings } = useSelector((state) => state.settings.settings);
  const { user } = useSelector((state) => state.auth);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [bookId, setBookId] = useState();
  const [bookClasses, setBookClasses] = useState([]);

  const classes = useSelector((state) => state.entities.classes);

  let sections = [];
  for (let index = 0; index < classes.classes?.length; index++) {
    const element = classes?.classes[index];
    sections = [...sections, ...element.sections.map((e) => e._id)];
  }

  const dropdownRef = useRef(null);
  const [isDropDownShown, setIsDropDownShown] = useState(false);
  /* Section Id  */
  const sectionIdStorage = (id) => {
    localStorage.setItem('sectionId', id);
  };
  /* ............ */
  const Toggle = () => {
    setIsDropDownShown((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    // Check if the click is outside the dropdown
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropDownShown(false); // Close the dropdown
    }
  };

  useEffect(() => {
    // Add event listener for clicks outside the dropdown
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Cleanup the event listener on component unmount
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleCourseSelection = (index) => {
    setSelectedCourse(index);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(
      forStudent({
        onSuccess: (res) => {},
        onError: (err) => {},
      })
    );
  }, []);

  useEffect(() => {
    if (bookClasses?.length >= 1) {
      setSelectedCourse(0); // Set the first class as the default selected
    }
  }, [bookClasses]);

  /* For Rendring Book */
  useEffect(() => {
    dispatch(
      studentClassSection({
        onSuccess: (res) => {
          const data = res?.data?.data || [];
          if (data.length > 0) {
            setBookClasses(data);

            const bookIdFromRes = data[0]?.classes?.book; // Extract the book ID from the first element
            if (bookIdFromRes) {
              setBookId(bookIdFromRes); // Set the book ID state
            } else {
              console.error('Book ID is missing in the response.');
            }
          } else {
            console.error('No class section data found.');
          }
        },
        onError: (err) => {
          console.error('Error fetching student class section:', err);
        },
      })
    );
  }, [dispatch]);

  useEffect(() => {
    // Only call the API if bookId is present
    if (bookId) {
      dispatch(
        getBook({
          id: bookId,
          onSuccess: (res) => {},
          onError: (err) => {},
        })
      );
    } else {
    }
  }, [bookId]);

  /*--------------------------- */

  return (
    <div
      className='row header-parent-padding'
      style={{
        // gap: "16px",
        justifyContent: 'space-between',
        '--bs-gutter-x': '0',
        '--bs-gutter-y': '0',
        padding: '0px 10px 0px 16px',
        ...style,
      }}
    >
      <div className='col-xl-7 col-lg-12' style={{ width: searchBarWidth || '60%' }}>
        <div className='new_header_wrap'>
          <div className='search_wrap'>
            <div className='form-group search_input_wrap'>
              <input type='text' className='search_input' placeholder='Search in book' />{' '}
              <button className='serch_btn_new'>
                <img src={searchImg} className='search_icon' alt='search' />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='col-xl-5 col-lg-12 ' style={{ paddingLeft: '0px', width: dropdownWidth || '38%' }}>
        <div
          className='icon_with_student_button new_header_inner '
          style={{
            paddingTop: '14px',
            justifyContent: 'space-between',
            paddingRight: '12px',
          }}
        >
          <div className='d-flex align-items-center gap-4'>
            <a
              onClick={(e) => {
                e.preventDefault();
                if (settings.siteMode !== 'student') return;
                dispatch(toggleBookMode());
              }}
            >
              <img src={settings.bookMode ? teextImg : textImg} alt='text' width={24} height={24} className='text_icon-header ' />
            </a>
            <a href='https://docs.greyled.com' target='_blank' rel='noreferrer'>
              <img src={question} alt='question' width={24} height={24} className='question text_icon-header' />
            </a>
          </div>
          <div className='dropdown explore_btn' style={{ width: '53%' }} ref={dropdownRef}>
            <div className='form-group' onClick={Toggle}>
              <div className='form_control w-100' style={{ height: 'none' }}>
                <div className='select_class_parent d-flex justify-content-between w-100'>
                  <p className='f_12 '>Class Select</p>
                  <img className='toggle_class_sel_arrow' src={isDropDownShown ? arrowUp : arrowDown} alt='arrow' />
                </div>
              </div>
            </div>
            {isDropDownShown ? (
              <div className='inner-option'>
                <p className='f13'>Choose current class </p>

                <div>
                  <ul>
                    {bookClasses.map((el, index) => (
                      <li key={index}>
                        <div className='iagree_radio radio_list'>
                          <input
                            type='radio'
                            name='Due-next'
                            id={`option_${index}`}
                            className=''
                            checked={index === selectedCourse}
                            onChange={() => handleCourseSelection(index)}
                            onClick={() => {
                              if (!canLeave) {
                                setIsShowModal(true);
                                setModelSuccessUrl('/studentlearn');
                                setDropDownActions({
                                  bookId: el?.classes?.book,
                                  sectionId: el.sections._id,
                                });
                              } else {
                                if (el.classes.book) {
                                  // Make sure the book ID exists
                                  dispatch(
                                    getBook({
                                      id: el.classes.book, // Use the book ID from the item
                                      onSuccess: (res) => {},
                                      onError: (err) => {},
                                    })
                                  );

                                  // Store the section ID
                                  sectionIdStorage(el.sections._id);
                                } else {
                                }
                              }
                              setIsDropDownShown((prev) => !prev);
                            }}
                          />
                          <label htmlFor={`option_${index}`} className='drop_down_list'>
                            {`${el.classes.courseNumber} | ${el.sections.sectionName} ${el.sections.sectionNumber.split('-')[0]}`}
                          </label>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : null}
          </div>

          <div className='user_wrap d-flex align-items-center gap-4' style={{ marginLeft: '6px' }}>
            <img
              src={dashboard}
              alt='dashboard'
              width={24}
              height={24}
              className='cursor'
              onClick={(e) => {
                e.preventDefault();
                if (!canLeave) {
                  setIsShowModal(true);
                  setModelSuccessUrl('/studentdashboard/overview');
                } else {
                  navigate('/studentdashboard/overview');
                }
              }}
            />
            <img src={bellImg} alt='bell' className='bell cursor' width={24} height={24} />
            <div className='dropdown explore_btn cursor'>
              <ProfileDropdown user={user} from="student" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
